import usePrivateAxios from '@/common/api/usePrivateAxios'
import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { MaintenaceWorkflowData } from '../types/maintenanceWorkflows.type';
import { ApiShowResponse } from '@/common/types/requests';

export const useMaintenanceWorkflow: (id: string | undefined) => UseQueryResult<MaintenaceWorkflowData, unknown> = (id) => {
  const privateAxios = usePrivateAxios();

  return useQuery<ApiShowResponse<MaintenaceWorkflowData>, unknown, MaintenaceWorkflowData>({
    enabled: !!id,
    queryKey: ['maintenanceWorkflow', id],
    queryFn: () => privateAxios.get(`/maintenance/workflows/${id}`),
    select: (data) => data?.data?.data,
  });
}
